var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrhuLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.952,
    height: 53.225,
    viewBox: "0 0 52.952 53.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M48.832,59.919c0,12.113-9.532,18.774-27,16.08,7.348-4.858,8.17-8.6-6.084-14.139,0-12.113,5.923-23.874,15.587-23.874s17.5,9.82,17.5,21.932",
    transform: "translate(-9.777 -23.588)",
    fill: "#63929c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M23.074,127.05s0-2.733,1.674-3.618,4.318-.993,5.532-2.006a15.415,15.415,0,0,0,2.284-2.533s.074,4.639-2.811,6.429a13.99,13.99,0,0,1-6.679,1.728",
    transform: "translate(-14.328 -73.826)",
    fill: "#f5ce52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M17.12,64.707s-1.719-3.077-8.5-3.622a7.462,7.462,0,0,1,4.237-1.464,6.5,6.5,0,0,0-3.233-2.759,9.43,9.43,0,0,1,6.035,1.552c2.931,1.983,1.465,6.294,1.465,6.294",
    transform: "translate(-5.349 -35.283)",
    fill: "#2a4a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M45.115,66.779s1.4-2.195,5.269-1.268a24.183,24.183,0,0,1,7.356,3.463c-1.68-1.647-4.239-5.513-6.235-5.763a10.108,10.108,0,0,1,6.1-1.521s-2.174-2.432-7.474-1.678-5.017,6.768-5.017,6.768",
    transform: "translate(-28.012 -37.173)",
    fill: "#2a4a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M54.927,92.067a5.676,5.676,0,0,0,1.594-1.01,8.755,8.755,0,0,0,1.574-5.28,7.115,7.115,0,0,0-1.712-5.135C56,80.211,54.757,79.4,55.4,79.514l3.553.546a1.978,1.978,0,0,1,1.1.569c.8.843,2.347,2.753,2.348,4.875a7.189,7.189,0,0,1-3.108,5.976,2.1,2.1,0,0,1-.856.34Z",
    transform: "translate(-34.223 -49.386)",
    fill: "#2a4a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M23.707,90.242c-.4.111-.7-.48-.484-.948a13,13,0,0,0,.952-5.28,10.284,10.284,0,0,0-1.036-5.135c-.234-.432-1.248-1.438-.86-1.325l2.414.743a1.164,1.164,0,0,1,.665.569,10.356,10.356,0,0,1,1.42,4.875,8.933,8.933,0,0,1-1.88,5.976,1.066,1.066,0,0,1-.518.34Z",
    transform: "translate(-13.856 -48.187)",
    fill: "#2a4a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M88.553,68.883s7.726-1.2,11.661-4.189c5.4-4.1,7.724-11.888,7.724-11.888-2.663,2.674-5.907,3.649-9.776,4.065,4.256-4.346,6.369-9.058,5.237-14.915-.816,3.548-12.611,7.932-11.5,13.83a15,15,0,0,1-3.35,13.1",
    transform: "translate(-54.986 -26.053)",
    fill: "#2a4a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M33.812,20.511s.628-7.792,3.323-11.937C40.832,2.891,48.425,0,48.425,0c-2.471,2.852-3.206,6.159-3.338,10.048,4.022-4.563,8.567-7.015,14.491-6.316C56.1,4.805,52.592,16.89,46.628,16.211a15,15,0,0,0-12.816,4.3",
    transform: "translate(-20.995 0)",
    fill: "#2a4a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M6.564,6.676c0,3.687-1.469,6.676-3.282,6.676S0,10.363,0,6.676,1.469,0,3.282,0,6.564,2.989,6.564,6.676",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 4.823, 29.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M51.882,85.78C51.882,89.217,49.875,92,47.4,92s-4.482-2.786-4.482-6.223,2.007-6.223,4.482-6.223,4.482,2.786,4.482,6.223",
    transform: "translate(-26.845 -49.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M18.524,79.618,14.3,89.129c.606,1.348,1.5,2.2,2.508,2.2,1.826,0,3.306-2.828,3.306-6.316a8.6,8.6,0,0,0-1.588-5.4",
    transform: "translate(-8.878 -49.438)",
    fill: "#bf8ca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M16.03,77.276a1.8,1.8,0,0,0-.533-.083c-1.826,0-3.306,2.828-3.306,6.316a11.371,11.371,0,0,0,.285,2.564Z",
    transform: "translate(-7.57 -47.932)",
    fill: "#bf8ca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M50.94,81.681l-5.806,9.511a4.16,4.16,0,0,0,3.446,2.2c2.509,0,4.543-2.828,4.543-6.316a7.1,7.1,0,0,0-2.182-5.4",
    transform: "translate(-28.026 -50.719)",
    fill: "#bf8ca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M47.515,79.34a3.325,3.325,0,0,0-.733-.083c-2.509,0-4.543,2.828-4.543,6.316a8.423,8.423,0,0,0,.391,2.564Z",
    transform: "translate(-26.228 -49.214)",
    fill: "#bf8ca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M14.243,96.136S5.421,98.653,2.992,99.842s-3.1,2.739-2.979,4.393c.168,2.364,2.979,5.033,2.979,5.033s1.807-3.157,4.722-3.157,5.157,1.235,7.719.641,2.974-1.922,2.974-1.922a12.078,12.078,0,0,1-3.283-3.579c-.915-1.464-.881-5.115-.881-5.115",
    transform: "translate(0 -59.695)",
    fill: "#f5ce52"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrhuLogo);
export default __webpack_public_path__ + "static/media/DRHULogo.27ab2c555fdb253e924300f0eb3d3715.svg";
export { ForwardRef as ReactComponent };